/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-multi-comp */
/* eslint-disable no-confusing-arrow */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable prefer-template */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { useMutation } from '@apollo/client';
import { MARK_NOTIFICATION_READ } from 'pages/Notifications/NotificationGraphQL';
import { toast } from 'react-toastify';
import DateFormatter from 'components/DateFormatter';
import NoDataFound from 'components/NoDataFound';

const Notifications = ({
  data,
  handleClick,
  totalPages,
  currentPageNo,
  handlePageChange,
  pageSize,
}) => {
  const [markNotificationRead] = useMutation(MARK_NOTIFICATION_READ, {
    refetchQueries: ['notifications'],
    onCompleted: (data) => {
      // API hit successfully, no toast needed
    },
    onError: (err) => {
      console.error('Error marking notification as read:', err);
      toast.error(err.message || 'Failed to mark as read');
    }
  });

  const onPageChange = async (pageIndex, pageSize) => {
    await handlePageChange({ pageNo: pageIndex, pageSize });
  };

  const handleNotificationClick = (item) => {
    if (!item?.isAdminOpened && item?.id) {
      markNotificationRead({ variables: { notificationId: item.id } });
    }
    handleClick(item);
  };

  return (
    <div>
      {data?.notifications?.notifications.length ? (
        data?.notifications?.notifications.map(
          (notificationItem) => {
            const { id, message, createdAt, isAdminOpened } = notificationItem;
            return (
              <div
                key={id}
                className="notifi-list"
                onClick={() => handleNotificationClick(notificationItem)}
                style={{
                  backgroundColor: isAdminOpened ? 'transparent' : '#f0f8ff',
                  cursor: 'pointer'
                }}
              >
                <span
                  className="notifi-list-hover"
                  style={{ display: 'block', fontWeight: isAdminOpened ? 'normal' : '500' }}
                >
                  {message}{' '}
                </span>
                <span>
                  {createdAt && (
                    <DateFormatter
                      className="date-inline mt-1"
                      dateTime={createdAt}
                    />
                  )}
                </span>
              </div>
            );
          },
        )
      ) : (
        <div className="pb-5">
          <NoDataFound message="Notifications not available" />
        </div>
      )}
      {totalPages ? (
        <div className="d-flex mt-3 align-items-center justify-content-end">
          <span className="text-active text-nowrap f-12">
            {currentPageNo} of {totalPages}
          </span>
          <select
            className="page-select form-select table-select f-12 fw-normal mx-3 d-inline-block"
            value={pageSize}
            // onChange={(e) => {
            //   onPageChange(currentPageNo, Number(e.target.value));
            // }}
            onChange={(e) => {
              if (totalPages === currentPageNo) {
                onPageChange(1, Number(e.target.value));
              } else {
                onPageChange(currentPageNo, Number(e.target.value));
              }
            }}
          >
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize} per page
              </option>
            ))}
          </select>
          <div className="pagination">
            <button
              onClick={() => onPageChange(1, pageSize)}
              disabled={currentPageNo <= 1}
            >
              {'<<'}
            </button>
            <button
              onClick={() => onPageChange(currentPageNo - 1, pageSize)}
              disabled={currentPageNo === 1}
            >
              {'<'}
            </button>
            <button
              onClick={() => onPageChange(currentPageNo + 1, pageSize)}
              disabled={currentPageNo >= totalPages}
            >
              {'>'}
            </button>
            <button
              onClick={() => onPageChange(totalPages, pageSize)}
              disabled={currentPageNo >= totalPages}
            >
              {'>>'}
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Notifications;
